import { loadableWithFallback } from '@vision/ui/utils';
import type { TableChart1Props } from './TableChart1';

export const TableChart1 = loadableWithFallback<TableChart1Props>(() => import('./TableChart1'));
